// extracted by mini-css-extract-plugin
export var stat = "stats-module--stat--a270c";
export var statMetric = "stats-module--statMetric--ec44b";
export var statUnit = "stats-module--statUnit--91b92";
export var statsWrapper = "stats-module--statsWrapper--173bd";